import React from 'react';

const Table = ({ 
  columns = [], 
  data = [], 
  onRowClick = null,
  className = '',
  emptyMessage = 'No hay datos disponibles'
}) => {
  const handleRowClick = (rowData, index) => {
    if (onRowClick) {
      onRowClick(rowData, index);
    }
  };

  const renderCellContent = (item, column) => {
    if (column.render) {
      return column.render(item[column.key], item);
    }
    
    if (column.key.includes('.')) {
      // Soporte para propiedades anidadas (ej: "usuario.nombre")
      return column.key.split('.').reduce((obj, key) => obj?.[key], item);
    }
    
    return item[column.key];
  };

  return (
    <div className={`w-full overflow-x-auto rounded-lg shadow-md bg-white ${className}`}>
      <table className="w-full border-collapse text-sm font-sans">
        <thead>
          <tr>
            {columns.map((column) => (
              <th 
                key={column.key} 
                className={`bg-gray-50 text-gray-700 font-semibold px-3 py-4 text-left border-b-2 border-gray-200 whitespace-nowrap ${column.headerClassName || ''}`}
                style={{ 
                  width: column.width,
                  textAlign: column.align || 'left'
                }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center text-gray-500 italic py-6">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr 
                key={item.id || index} 
                className={`border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200 ${onRowClick ? 'cursor-pointer hover:bg-gray-100' : ''}`}
                onClick={() => handleRowClick(item, index)}
              >
                {columns.map((column) => (
                  <td 
                    key={`${item.id || index}-${column.key}`}
                    className={`px-3 py-3 text-gray-800 align-middle md:px-3 md:py-3 sm:px-2 sm:py-2 ${column.cellClassName || ''}`}
                    style={{ textAlign: column.align || 'left' }}
                  >
                    {renderCellContent(item, column)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;